module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.b45ced8e.svg";